var KeyCodes;
(function (KeyCodes) {
    KeyCodes[KeyCodes["Tab"] = 9] = "Tab";
    KeyCodes[KeyCodes["Enter"] = 13] = "Enter";
    KeyCodes[KeyCodes["Escape"] = 27] = "Escape";
    KeyCodes[KeyCodes["Up"] = 38] = "Up";
    KeyCodes[KeyCodes["Down"] = 40] = "Down";
})(KeyCodes || (KeyCodes = {}));
var Palette;
(function (Palette) {
    Palette["Bianco"] = "#ffffff";
    // Neutrals
    Palette["NeutralGrey1"] = "#3c4858";
    Palette["NeutralGrey2"] = "#717e8f";
    Palette["NeutralGrey3"] = "#aeb9c6";
    Palette["NeutralGrey4"] = "#dfe3ed";
    Palette["NeutralGrey5"] = "#f7f8fb";
    // Primaries
    Palette["RedCorporateD2"] = "#a62133";
    Palette["RedCorporateD1"] = "#cb3035";
    Palette["RedCorporate"] = "#f9423a";
    Palette["RedCorporateL1"] = "#fa7b75";
    Palette["RedCorporateL2"] = "#fcb3b0";
    Palette["RedCorporateL3"] = "#feeceb";
    Palette["BlueMotoriD2"] = "#11277f";
    Palette["BlueMotoriD1"] = "#1c3eb7";
    Palette["BlueMotori"] = "#2650ff";
    Palette["BlueMotoriL1"] = "#6796ff";
    Palette["BlueMotoriL2"] = "#a8c3ff";
    Palette["BlueMotoriL3"] = "#e9edff";
    Palette["GreenLavoroD2"] = "#006164";
    Palette["GreenLavoroD1"] = "#008f7f";
    Palette["GreenLavoro"] = "#07bb9c";
    Palette["GreenLavoroL1"] = "#4dd2ae";
    Palette["GreenLavoroL2"] = "#99e5d5";
    Palette["GreenLavoroL3"] = "#e6f8f5";
    Palette["YellowMarketD2"] = "#994d00";
    Palette["YellowMarketD1"] = "#d88300";
    Palette["YellowMarket"] = "#f2a700";
    Palette["YellowMarketL1"] = "#f5c058";
    Palette["YellowMarketL2"] = "#f9d999";
    Palette["YellowMarketL3"] = "#fdf6e5";
    Palette["PurpleImmobiliD2"] = "#3d1090";
    Palette["PurpleImmobiliD1"] = "#5819b8";
    Palette["PurpleImmobili"] = "#9924ff";
    Palette["PurpleImmobiliL1"] = "#b26bff";
    Palette["PurpleImmobiliL2"] = "#d3aaff";
    Palette["PurpleImmobiliL3"] = "#f4e9ff";
})(Palette || (Palette = {}));
/**
 * Use the Spacing Scale when building individual elements. It includes minute
 * increments needed to create appropriate spacial relationships for detail-level designs.
 *
 * Best for smaller, more refined spacing situations, specifically within the
 * context of a component (ie. the space between a label and a Text Input).
 *
 * The root size (base) for Rem units is spacing-md (16px).
 */
var SpacingScale;
(function (SpacingScale) {
    SpacingScale["XXXS"] = "2px";
    SpacingScale["XXS"] = "4px";
    SpacingScale["XS"] = "8px";
    SpacingScale["SM"] = "12px";
    SpacingScale["MD"] = "16px";
    SpacingScale["LG"] = "20px";
    SpacingScale["XL"] = "24px";
    SpacingScale["XXL"] = "32px";
    SpacingScale["XXXL"] = "40px";
})(SpacingScale || (SpacingScale = {}));
var CornerRounding;
(function (CornerRounding) {
    CornerRounding["Null"] = "0";
    CornerRounding["Sm"] = "2px";
    CornerRounding["Md"] = "4px";
    CornerRounding["Lg"] = "8px";
})(CornerRounding || (CornerRounding = {}));
var OpacityScale;
(function (OpacityScale) {
    OpacityScale["Opacity1"] = "1";
    OpacityScale["Opacity2"] = "0.85";
    OpacityScale["Opacity3"] = "0.65";
    OpacityScale["Opacity4"] = "0.45";
    OpacityScale["Opacity5"] = "0.25";
})(OpacityScale || (OpacityScale = {}));
/**
 * The Layout Scale is used for arranging components and other UI parts into a
 * full page layout. It has larger increments that are used to control the
 * density of a design. Use the smaller layout tokens to create more dense
 * compositions and direct relationships. Use the larger tokens to increase the
 * amount of white space and to disassociate sections.
 *
 * The Layout Scale controls the amount of white space set between larger elements.
 */
var LayoutScale;
(function (LayoutScale) {
    LayoutScale["XXS"] = "16px";
    LayoutScale["XS"] = "24px";
    LayoutScale["SM"] = "32px";
    LayoutScale["MD"] = "48px";
    LayoutScale["LG"] = "64px";
    LayoutScale["XL"] = "96px";
    LayoutScale["XXL"] = "160px";
})(LayoutScale || (LayoutScale = {}));
const DeviceWidth = {
    mobile: { max: '767px' },
    tablet: { min: '768px', max: '979px' },
    desktop: { min: '980px' },
};
var BoxShadow;
(function (BoxShadow) {
    BoxShadow["Raised"] = "0 1px 4px 0 rgba(0,0,0,0.10)";
    BoxShadow["Sticky"] = "0 4px 12px 0 rgba(0,0,0,0.10)";
    BoxShadow["Pop"] = "0 10px 24px 0 rgba(0,0,0,0.10)";
})(BoxShadow || (BoxShadow = {}));
var IconSize;
(function (IconSize) {
    IconSize["SM"] = "16px";
    IconSize["MD"] = "24px";
    IconSize["LG"] = "32px";
    IconSize["XL"] = "48px";
})(IconSize || (IconSize = {}));
/**
 * The size of logos in pixels.
 * The unit is NOT included in the value: these will most likely be used
 * in img width and height attributes which take only numbers.
 */
var LogoSize;
(function (LogoSize) {
    LogoSize["LG"] = "40";
    LogoSize["XL"] = "64";
})(LogoSize || (LogoSize = {}));

export { BoxShadow, CornerRounding, DeviceWidth, IconSize, KeyCodes, LayoutScale, LogoSize, OpacityScale, Palette, SpacingScale };
//# sourceMappingURL=constants.js.map
